export const main = {
    "name": "Jude K.",
    "occupation": "Full-Stack Engineer",
    "description": "I'm a Full-stack Engineer",
    "image": "profile.jpeg",
    "bio": "I’m a full-stack engineer (web & blockchain). Worked as a senior lead full-stack developer at OpticEngine had been a rewarding experience. Moreover, I work on a few startups aimed at the Bangladesh, Russian, Chinese, American, and Dutch markets. Among the companies and entrepreneurs I have worked with are DP-Websolutions, Ganlax group, Hyvinvoivin, Happy-Dairy, Arrtal, FN Softwares & institute, and many more. Developing software for the world of intent is something I'm passionate about and I'm dedicated to making the world of intent easy and affordable for everyone.",
    "email": "judekinsley911@gmail.com",
    "phone": "07975 382621",
    "quote": "The universe is a pretty big place. If it's just us.",
    "address": "18 Fenton Fields, Rotherham, South Yorkshire, S61 3SU",
    "website": "https://jk.vercel.app",
    "resumedownload": "https://drive.google.com/file/d/1zVyZhAvq3x8C1CaEFjAMWvGXKBo9zVnf/view?usp=sharing",
    "social": [
        {
            "name": "linkedin",
            "url": "https://linkedin.com/in/jude-k-32220b308",
            "iconName": "logo-linkedin"
        },
        {
            "name": "youtube",
            "url": "https://www.youtube.com/",
            "iconName": "logo-youtube"
        },
        {
            "name": "twitter",
            "url": "https://twitter.com/",
            "iconName": "logo-twitter"
        },
        {
            "name": "facebook",
            "url": "https://www.facebook.com/",
            "iconName": "logo-facebook"
        },
        {
            "name": "instagram",
            "url": "https://www.instagram.com/",
            "iconName": "logo-instagram"
        },
        {
            "name": "github",
            "url": "https://github.com/satoterin",
            "iconName": "logo-github"
        }
    ]
}

export const about = {
    "bio": "I am a software <br /><span class='text-primary'>engineer</span> who cares<br /> about the code and the people.",
    "ido": "<p>Vue.js/React.js</p><p>Javascript/Typescript</p><p>Python/Rust/Go</p><p>Laravel/Django</p><p>EVM/Solana</p><p>NFTs/DeFi</p>",
    "years": 7,
    "image": "img/profile.jpeg",
    // "video": "https://www.youtube.com/watch?v=ghQd1PbzVaY",
    "resumedownload": "https://drive.google.com/file/d/1zVyZhAvq3x8C1CaEFjAMWvGXKBo9zVnf/view?usp=sharing",
}

export const works = [
    [
        {
            "company": "Freelance",
            "title": "Software Engineer",
            "image": "img/behance.png",
            "years": "May 2021 - Present",
            "description": "• Developed Pegasus game token IDO project of Pegasus Metaverse MMORPG <br />• Creation of HowToTube website(VideoPlatform) using React, Python, Flask, PostgreSQL, SQLAlchemy and RESTful design as full-stack web application <br />• Working with event-driven architectures, Redis, Golang, PostgreSQL and cloud services, like GCP or AWS <br />•  Working with Hardhat and Geth or other development frameworks and local environments <br />• Exploring Cosmos SDK projects and other projects that will be built on the cosmos <br />• Full-stack programming with focus on using strongly typed languages (Rust, Golang, Typescript) <br />• Crypto Coins Exchange Development, ICO & IDO Development with Created Token"
        },
        {
            "company": "ConsiderIT",
            "title": "Web Full-Stack Developer & Blockchain Developer",
            "image": "img/behance.png",
            "years": "August 2020 - April 2021",
            "description": "• NFT (Non-Fungible Token) Marketplace and Mint site Development <br />• Solidity smart contract development, management, processes, best practices, debugging and testing tools <br />• Designed and provided web solutions for a number of small businesses using Wordpress, Jamstack CMSs, social network/Web APIs, e-commerce pay modules <br />• Architected and led a development team building core apps and NLP based chatbot using React.js, Vue.js, GraphQL and Node.js <br />• Developed dynamic and interactive website that ensured high traffic, page views, and user experience, resulting in 40% increase in sales revenu"
        },
        {
            "company": "BITS Technology Group",
            "title": "Lead Full-Stack Developer & Project Manager",
            "image": "img/behance.png",
            "years": "February 2019 - August 2020",
            "description": "• Developed a React web app (DApp) for blockchain-based track and trade systems <br />• Introduced an IBFT consensus algorithmand contributed to big mining pool on the AION network <br />• Designed and built the User Interface of the mobile app with React-native <br />• Assist the backend developer on ongoing development projects <br />• Participating in all decision-making processes which includes the database design, tooling, deployment processes etc"
        }
    ],
    [
        {
            "company": "Genic Solutions",
            "title": "Web Developer",
            "image": "img/behance.png",
            "years": "October 2017 - February 2019",
            "description": "• Created a Django (Python) web application for a company that works with insurance companies and radiologists. The work included updating Django admin pages and working with bulk imports of CSV data <br />• Deployed full-stack web applications to AWS EC2, and RDS <br />• Developed a web application foran IT support company that involved building Python back-end and JavaScript front-end. Also built charts to visually display information about client computers <br />• Utilise jQuery, AJAX and AngularJS to redesign the UI functionality of 5+ multithreaded apps running on mobiles, tablets, and other touchscreen devices <br />• Performed maintenance tasks on pre-existing sites using the Infinite WP dashboard, such as updating plugins, ensuring backups are running, and running security scans"
        },
        {
            "company": "Vinova Pte. Ltd.",
            "title": "Intern Web Developer & Full-Stack Developer",
            "image": "img/behance.png",
            "years": "October 2015 - September 2017",
            "description": "• Utilise jQuery, AJAX and AngularJS to redesign the UI functionality of 5+ multi-threaded apps running on mobiles, tablets, and other touchscreen devices <br />• Software development using ElectronJS+Node.js+Vue.js for a Marijuana Medicinal company <br />• Maintained complex technology infrastructure and collaborated with product team to implement new features and strategically plan for future products <br />• Worked as an adviser on decision-making processes • Conducted unit and load testing for high profile customer facing applications, which reduced system failure rate by 70% "
        }
    ]
]

export const skills = {
    title: "My mission is to create an impact <span class='text-primary'>globally</span>",
    subtitle: "Developing software for the world of intent is something I'm passionate about and I'm dedicated to making the world of intent easy and affordable for everyone.",
    skills: [
        {
            "title": "Ninja at",
            skills: ["JavaScript", "TypeScript", "React JS", "Vue", "Ethereum", "Web3.js", "Ethers.js"]
        },
        {
            "title": "Expert at",
            skills: ["Golang", "Python", "Next JS", "Node JS", "Express JS", "MongoDB", "MySQL", "CI/CD", "AWS", "GCP"]
        },
        {
            "title": "Good at",
            skills: ["Redux", "Solidity", "Firebase", "Git, GitHub", "gRPC", "Tailwind CSS", "Rest APIs", "Kubernetes", "Docker", ]
        },
        {
            "title": "Cool at",
            skills: ["PWA", "SEO", "Figma", "PHP", "Rust", "GraphQL", "Cosmos SDK", "Material UI", "RabbitMQ", "Storybook"]
        },
    ]
}

export const projects = [
    {
        "title": "Business website",
        "category": "Website",
        "image": "business2.png",
        "url": "https://megakit-web.netlify.app"
    },
    {
        "title": "Zeppto website",
        "category": "Website",
        "image": "zeptto.png",
        "url": "https://zeppto.netlify.app"
    },
    {
        "title": "Decentralised chat application",
        "category": "Blockchain",
        "image": "web3.png",
        "url": "https://meta-ks.vercel.app/"
    },
    {
        "title": "Food delivery app - (Play store)",
        "category": "App",
        "image": "Kennys Fish & Chips.png",
        "url": "https://play.google.com/store/apps/details?id=com.kennysfishandchips.app"
    },
    {
        "title": "VS Code - Extension for eSomaz",
        "category": "VS Code - Extension",
        "image": "esomax-ext.jpg",
        "url": "https://marketplace.visualstudio.com/items?itemName=coderkhalid.esomaz"
    },
    {
        "title": "Arrtal - Short videos for kids (app)",
        "category": "App",
        "image": "arrtal-app.jpg",
        "url": "https://play.google.com/store/apps/details?id=com.arrtal.arrtalkids"
    },
    {
        "title": "Arrtal creator app",
        "category": "App",
        "image": "creator-app.jpg",
        "url": "https://www.youtube.com/watch?v=QdcaNakkbCI"
    },
    {
        "title": "WhatsApp app clone - React Native",
        "category": "App",
        "image": "whatsapp-app.jpg",
        "url": "https://youtu.be/tMmfcAipfW4"
    },
    {
        "title": "Uber Eats clone - React Native",
        "category": "App",
        "image": "uber-eats.jpg",
        "url": "https://youtu.be/Z7rS3PM3Ap4"
    },
    {
        "title": "Pienipuro.fi",
        "category": "Website",
        "image": "pienipuro.jpg",
        "url": "https://pienipuro.fi"
    },
    {
        "title": "1 to 1 - Video calling application",
        "category": "Website",
        "image": "video-calling.jpg",
        "url": "https://videocall-ks.herokuapp.com"
    },
    {
        "title": "Quotes World App",
        "category": "App",
        "image": "quotes.jpg",
        "url": "https://play.google.com/store/apps/details?id=com.quotes.ksdevware"
    },
    {
        "title": "Airbnb clone - Next JS",
        "category": "Website",
        "image": "airbnb.jpg",
        "url": "https://airbnb-clone-ks.vercel.app"
    },
    {
        "title": "Uber clone - react native",
        "category": "App",
        "image": "uber-clone.jpg",
        "url": "https://expo.io/@coderkhalid/projects/uber-clone"
    },
    {
        "title": "Arrtal app admin dashboard",
        "category": "Admin Website",
        "image": "arrtal-admin.jpg",
        "url": "https://arrtal-admin.vercel.app"
    },
    {
        "title": "Amazon clone - Full-stack with stripe checkout",
        "category": "Website",
        "image": "amazon.jpg",
        "url": "https://pocotep.com"
    },
    {
        "title": "Hyvinvoivin.fi",
        "category": "Website",
        "image": "hyvn.jpg",
        "url": "https://hyvinvoivin.fi"
    },
    {
        "title": "GanlaxGroup.co.uk",
        "category": "Website",
        "image": "ganlax.jpg",
        "url": "http://ganlaxgroup.co.uk"
    },
    {
        "title": "Daily-dairy.com",
        "category": "Website",
        "image": "daily-dairy.jpg",
        "url": "https://daily-dairy.com"
    },
    {
        "title": "KhalidDev.com",
        "category": "Website",
        "image": "resume.jpg",
        "url": "https://coderkhalid.netlify.app"
    },
    {
        "title": "Amanti.com",
        "category": "Website",
        "image": "amanti.jpg",
        "url": "https://amanti-cheese.com"
    },
    {
        "title": "Zoom Clone",
        "category": "Website",
        "image": "zoom-clone.jpg",
        "url": "https://ksdevware.com/dekto"
    },
    {
        "title": "Peer4Tree.com",
        "category": "UI/UX Design",
        "image": "peer4tree.jpg",
        "url": "https://peer4-tree.web.app"
    },
    {
        "title": "MERN blog website",
        "category": "Website",
        "image": "loomly.jpg",
        "url": "https://ks-loomly.herokuapp.com"
    },
    {
        "title": "Whatsapp clone",
        "category": "Website",
        "image": "whatsapp.jpg",
        "url": "https://whatsapp-clone-nextjs-six.vercel.app"
    },
    {
        "title": "KS Classroom (LMS)",
        "category": "Website",
        "image": "classroom.jpg",
        "url": "https://ksdevware.com/classroom"
    },
    {
        "title": "Prolingua.fi",
        "category": "Website",
        "image": "prolingua.jpg",
        "url": "https://prolingua.fi"
    },
    {
        "title": "Peer4Car.com Dashboard UI",
        "category": "UI/UX Design",
        "image": "peer4-admin.jpg",
        "url": "https://www.figma.com/proto/yoQYmaIIPaTQapbwyzr4AI/PEER4-CAR?node-id=1%3A2&viewport=578%2C-192%2C0.38818028569221497&scaling=min-zoom&page-id=0%3A1"
    }
]

export const partners = [
    {
        image: "1.png"
    },
    {
        image: "2.webp"
    },
    {
        image: "4.png"
    },
    {
        image: "workslee.png"
    },
    {
        image: "gorelove.png"
    },
    {
        image: "3.png"
    },
]

export const testimonials = [
    {
        "text": "We are very content and happy wan all the work Lee has done for us! Not only did he just what he had to do, comes up with suggestions and improvements of his owns and points out weaknesses which he in perfect communication is able to improve. Recommended! ",
        "user": "Jason Sindram",
        "company": "CTO at DP-Websolutions"
    },
    {
        "text": "Superb. Great comms, understood the requirement, and delivered quickly. Multiple revisions allowed which were very helpful. I will work with him again.",
        "user": "Bhavesh Patel",
        "company": "CEO at Ganlaxgroup"
    }
]

